module.exports = __webpack_public_path__ + "static/trees-left-footer-043dd85c4c2568c0b57e3e4721705d7b.png";